module.exports = __webpack_public_path__ + "static/media/hero_bg.7319dc79.jpg";